// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const DefensiveGradientIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 40 40">
    <path
      fill="url(#defensive-gradient_svga)"
      d="m20 5.8 12.5 5.06v7.51a16.5 16.5 0 0 1-3.55 9.9A17.8 17.8 0 0 1 20 34.3a17.8 17.8 0 0 1-8.95-6.03 16.5 16.5 0 0 1-3.55-9.9v-7.5zm0-2.4a3 3 0 0 0-.98.19L6.52 8.66q-.69.28-1.11.88-.4.6-.41 1.32v7.51c.04 4.1 1.46 8.07 4.03 11.34a20 20 0 0 0 10.28 6.86q.69.2 1.38 0c4.11-1.18 7.71-3.6 10.29-6.87A18.7 18.7 0 0 0 35 18.36v-7.5q0-.72-.4-1.32-.43-.6-1.12-.88l-12.5-5.14a3 3 0 0 0-.98-.19z"
    />
    <defs>
      <linearGradient
        id="defensive-gradient_svga"
        x1={5}
        x2={38.79}
        y1={3.33}
        y2={32.24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "DefensiveGradient",
);
export default DefensiveGradientIcon;
